import React, { memo } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Scroll to bottom button component
 * Shows when user has scrolled up from the bottom
 */
const ScrollToBottomButton = memo(({ isNearBottom, scrollToBottom }) => {
  if (isNearBottom) return null;

  return (
    <div className="sticky bottom-4 right-0 p-4 pointer-events-none w-full flex justify-end">
      <button
        onClick={() => scrollToBottom(true)}
        className="bg-brand-action hover:bg-brand-action-hover text-brand-action-text p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center z-10 pointer-events-auto"
        aria-label="Scroll to bottom"
      >
        <ChevronDown size={20} />
      </button>
    </div>
  );
});

ScrollToBottomButton.displayName = 'ScrollToBottomButton';

export default ScrollToBottomButton;